export const APP_SHELL_ATTRIBUTE = "data-app-shell";

let isAppShellReady = false;
const waiting = new Set<() => void>();

export function markAppShellReady(): void {
  isAppShellReady = true;
  for (const callback of waiting) callback();
  waiting.clear();
}

export function afterAppShellReady(callback: () => void): () => void {
  if (isAppShellReady || !document.querySelector(`[${APP_SHELL_ATTRIBUTE}]`)) {
    callback();
    return () => undefined;
  }
  waiting.add(callback);
  return () => waiting.delete(callback);
}
